<template>
  <div>
    <h6
      v-if="voucherData === null"
      class="heading-small text-muted mb-4 text-truncate"
    >
      Add Voucher
    </h6>
    <h6 v-else class="heading-small text-muted mb-4 text-truncate">
      Edit Voucher
    </h6>

    <form id="form-proper">
      <a-tabs :default-active-key="defaultTab">
        <a-tab-pane key="voucher-info" tab="Voucher Information">
          <div class="py-2" style="border-bottom: 1px solid #e0e0e0;">
            <div class="row">
              <div class="col">
                <base-input label="Voucher Type" required>
                  <a-select
                    v-model="$v.formData.voucher_type_id.$model"
                    :disabled="viewMode"
                    @change="setVoucherReward"
                  >
                    <a-select-option
                      v-for="voucherType in options.voucherTypes"
                      v-bind:value="voucherType.id"
                      v-bind:key="voucherType.id"
                    >
                      {{ voucherType.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="$v.formData.voucher_type_id.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.voucher_type_id.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Code" required>
                  <a-input v-model="$v.formData.code.$model" :disabled="viewMode" />
                  <div v-if="$v.formData.code.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.code.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
              <!-- <div class="col">
                <base-input label="Code Generation Type" required>
                  <a-select
                    v-model="$v.formData.codeType.$model"
                    :disabled="viewMode"
                  >
                    <a-select-option
                      v-for="(codeType, i) in options.codeTypes"
                      v-bind:value="codeType.value"
                      v-bind:key="i"
                    >
                      {{ codeType.name }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div> -->
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Name" required>
                  <a-input v-model="$v.formData.name.$model" :disabled="viewMode" />
                  <div v-if="$v.formData.name.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.name.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col">
                <base-input label="Voucher Status" required>
                  <a-select
                    v-model="$v.formData.status.$model"
                    :disabled="viewMode"
                  >
                    <a-select-option
                      v-for="(s, i) in options.status"
                      v-bind:value="s.value"
                      v-bind:key="i"
                    >
                      {{ s.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="$v.formData.status.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.status.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div> -->
            <br>
            <div class="row">
              <div class="col">
                <base-input label="Quantity" required>
                  <a-input v-model="$v.formData.qty.$model" :disabled="viewMode" />
                  <div v-if="$v.formData.qty.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.qty.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
              <!-- <div class="col">
                <base-input label="Price" required>
                  <a-input v-model="formData.price" :disabled="viewMode" />
                </base-input>
              </div> -->
            </div>
            <div  v-if="rewardValue == 'discount'" class="row">
              <div class="col">
                <base-input label="Reward Amount" required>
                  <a-input v-model="$v.reward.$model" :disabled="viewMode" @change="setVoucherRewardForm" />
                  <div v-if="$v.reward.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.reward.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div  v-if="rewardValue == 'barcodes'" class="row">
              <div class="col">
                <base-input label="Reward Barcode" required>
                  <a-input v-model="$v.reward.$model" :disabled="viewMode" @change="setVoucherRewardForm"/>
                  <div v-if="$v.reward.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.reward.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <!-- Voucher Content -->
        <a-tab-pane key="voucher-content" tab="Voucher Content" force-render>
          <div>
            <div class="row">
              <div class="col">
                <base-input label="Title" required>
                  <a-input v-model="$v.formData.title.$model" :disabled="viewMode" />
                  <div v-if="$v.formData.title.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.title.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Short Description" required>
                  <a-textarea
                    placeholder="Description"
                    :rows="4"
                    v-model="$v.formData.short_description.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.formData.short_description.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.short_description.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Terms and Conditions" required>
                  <a-textarea
                    placeholder="Terms and Conditions"
                    :rows="4"
                    v-model="$v.formData.terms.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.formData.terms.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.terms.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Duration Start" required
                  ><br />
                  <a-date-picker
                    v-model="formData.start_date"
                    :format="dateFormat"
                    :disabled="viewMode"
                  />
                </base-input>
              </div>
              <div class="col">
                <base-input label="Duration End" required
                  ><br />
                  <a-date-picker
                    v-model="formData.end_date"
                    :format="dateFormat"
                    :disabled="viewMode"
                  />
                </base-input>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <!-- Voucher Eligibility -->
        <a-tab-pane key="voucher-eligibility" tab="Voucher Eligibility" force-render>
          <div>
           <div class="row">
              <div class="col">
                <base-input label="Membership Program">
                  <a-select
                    v-model="membership_program_id"
                    :disabled="viewMode"
                    @change="getMembershipLevels"
                  >
                    <a-select-option
                      v-for="membership_program in options.membership_programs"
                      v-bind:value="membership_program.id"
                      v-bind:key="membership_program.id"
                    >
                      {{ membership_program.name }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>
            <div v-if="options.membership_levels.length > 0" class="row">
              <div class="col">
                <base-input label="Membership Levels">
                  <b-form-group>
                    <b-form-checkbox
                      v-for="membership_level in options.membership_levels"
                      v-model="membership_levels"
                      :key="membership_level.id"
                      :value="membership_level.id"
                      name="membership_levels"
                      :disabled="viewMode"
                    >
                      {{ membership_level.name }}
                    </b-form-checkbox>
                  </b-form-group>
                </base-input>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <!-- Voucher Conditions -->
        <!-- <a-tab-pane key="voucher-condition" tab="Voucher Conditions" force-render>
          <div>
            <div v-if="options.conditions.length > 0" class="row">
              <div class="col">
                <base-input label="Claiming Condition">
                  <b-form-group>
                    <b-form-checkbox
                      v-for="(condition, i) in options.conditions"
                      v-model="conditions"
                      :key="i"
                      :value="condition.value"
                      name="conditions"
                      :disabled="viewMode"
                    >
                      {{ condition.name }}
                    </b-form-checkbox>
                  </b-form-group>
                </base-input>
              </div>
            </div>
            <div class="row" v-if="conditions.includes('payment_types')">
              <div class="col">
                <base-input label="Payment Types" required>
                  <a-input v-model="payment_types_value" :disabled="viewMode" />
                </base-input>
              </div>
            </div>
            <div class="row" v-if="conditions.includes('sites')">
              <div class="col">
                <base-input label="Sites">
                  <b-form-group>
                    <b-form-checkbox
                      v-for="visiting_site in options.visiting_sites"
                      v-model="sites_value"
                      :key="visiting_site.id"
                      :value="visiting_site.id"
                      name="sites"
                      :disabled="viewMode"
                    >
                      {{ visiting_site.name }}
                    </b-form-checkbox>
                  </b-form-group>
                </base-input>
              </div>
            </div>
            <div class="row" v-if="conditions.includes('customer_types')">
              <div class="col">
                <base-input label="Customer Types" required>
                  <a-input v-model="customer_types_value" :disabled="viewMode" />
                </base-input>
              </div>
            </div>
            <div class="row" v-if="conditions.includes('min_amnt_purchased')">
              <div class="col">
                <base-input label="Minimmum Amount Purchased" required>
                  <a-input v-model="min_amnt_purchased_value" :disabled="viewMode" />
                </base-input>
              </div>
            </div>
          </div>
        </a-tab-pane> -->
      </a-tabs>
      <div
        style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;"
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="voucherData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createVoucher"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="editVoucher"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from "@/controllers/secureStorage";
import moment from 'moment';

export default {
  name: 'VoucherForm',
  props: {
    voucherData: Object,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      defaultTab: 'voucher-info',
      dateFormat: 'YYYY-MM-DD',
      reward: null,
      rewardValue: null,
      membership_program_id: null,
      membership_levels: [],
      payment_types: false,
      payment_types_value: null,
      sites: false,
      sites_value: [],
      customer_types: false,
      customer_types_value: null,
      min_amnt_purchased: false,
      min_amnt_purchased_value: null,
      conditions: [],
      formData: {
        name: null,
        start_date: null,
        end_date: null,
        voucher_rewards: {},
        voucher_listing_conditions: {},
        voucher_redemption_conditions: {},
        price: 0.00,
        status: 'A',
        short_description: null,
        terms: null,
        title: null,
        qty: null,
        voucher_type_id: null,
        code: null,
        codeType: 'constant',
      },
      options: {
        voucherTypes: [],
        sites: [],
        visiting_sites: secureStorage.getItem('visitingSites'),
        membership_programs: [],
        membership_levels: [],
        conditions: [
          {value: 'payment_types', name: 'Payment Types'},
          {value: 'sites', name: 'Sites'},
          {value: 'customer_types', name: 'Customer Types'},
          {value: 'min_amnt_purchased', name: 'Minimmum Amount Purchased'}
        ],
        codeTypes: [
          {value: 'series',name: 'Series'},
          {value: 'constant',name: 'Constant'},
        ]
      }
    };
  },

  validations () {
    let validation = {
      formData: {
        voucher_type_id: { required },
        code: { required },
        name: { required },
        qty: { required },
        title: { required },
        status: { required },
        short_description: { required },
        terms: { required },
        codeType: { required },
      },
      reward: { required}
    }
    return validation;
  },

  methods: {
    setVoucherRewardForm() {
      if(this.rewardValue == 'barcodes') {
        this.formData.voucher_rewards[this.rewardValue] = [this.reward];
      } else {
        this.formData.voucher_rewards[this.rewardValue] = this.reward;
      }
    },
    setVoucherReward() {
      this.reward = null;
      this.formData.voucher_rewards = {};
      this.options.voucherTypes.map((voucherType) => {
        if(voucherType.id == this.formData.voucher_type_id) {
          if(voucherType.code == 'PCTG_DSC') {
            this.rewardValue = 'discount';
          }
          if(voucherType.code == 'AMNT_DSC') {
            this.rewardValue = 'discount';
          }
          if(voucherType.code == 'FREE_ITEM') {
            this.rewardValue = 'barcodes';
            this.formData.voucher_rewards[this.rewardValue] = [];
          }
        }
      })
    },
    async getVoucherTypes() {
      const response = await HTTPRequest.getRequest('/api/v1/voucher_types');
      this.options.voucherTypes = response.data;
    },
    async getSites() {
      const response = await HTTPRequest.getRequest('/api/v1/sites', { per_page: 1000 });
      this.options.sites = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
      );
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest('/api/v1/clp_membership_programs', { per_page: 1000 });
      this.options.membership_programs = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
      );
    },
    async getMembershipLevels() {
      const response = await HTTPRequest.getRequest(`/api/v1/clp_membership_programs/${this.membership_program_id}/membership_levels`,
        { per_page: 1000 });
      this.options.membership_levels = response;
    },

    async createVoucher() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formData.voucher_rewards[this.rewardValue] = this.reward;
        this.formData.start_date = moment(this.formData.start_date).format(this.dateFormat);
        this.formData.end_date = moment(this.formData.end_date).format(this.dateFormat);
        if(this.membership_program_id != null) {
          this.formData.voucher_listing_conditions['membership_program'] = this.membership_program_id;

          if(this.membership_levels.length > 0) {
            this.formData.voucher_listing_conditions['membership_levels'] = this.membership_levels;
          }
        }
        if(this.conditions.includes('sites')) {
          this.formData.voucher_redemption_conditions['sites'] = this.sites_value;
        }
        if(this.conditions.includes('payment_types')) {
          this.formData.voucher_redemption_conditions['payment_types'] = this.payment_types_value;
        }
        if(this.conditions.includes('customer_types')) {
          this.formData.voucher_redemption_conditions['customer_types'] = this.customer_types_value;
        }
        if(this.conditions.includes('min_amnt_purchased')) {
          this.formData.voucher_redemption_conditions['min_amnt_purchased'] = this.min_amnt_purchased_value;
        }

        this.formData.voucher_listing_conditions = JSON.stringify(this.formData.voucher_listing_conditions);
        this.formData.voucher_rewards = JSON.stringify(this.formData.voucher_rewards);
        this.formData.voucher_redemption_conditions = JSON.stringify(this.formData.voucher_redemption_conditions);

        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest('/api/v1/vouchers', {
          voucher: this.formData,
        });

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },
    async editVoucher() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formData.voucher_rewards[this.rewardValue] = this.reward;
        this.formData.start_date = moment(this.formData.start_date).format(this.dateFormat);
        this.formData.end_date = moment(this.formData.end_date).format(this.dateFormat);
        if(this.membership_program_id != null) {
          this.formData.voucher_listing_conditions['membership_program'] = this.membership_program_id;

          if(this.membership_levels.length > 0) {
            this.formData.voucher_listing_conditions['membership_levels'] = this.membership_levels;
          }
        }
        if(this.conditions.includes('sites')) {
          this.formData.voucher_redemption_conditions['sites'] = this.sites_value;
        }
        if(this.conditions.includes('payment_types')) {
          this.formData.voucher_redemption_conditions['payment_types'] = this.payment_types_value;
        }
        if(this.conditions.includes('customer_types')) {
          this.formData.voucher_redemption_conditions['customer_types'] = this.customer_types_value;
        }
        if(this.conditions.includes('min_amnt_purchased')) {
          this.formData.voucher_redemption_conditions['min_amnt_purchased'] = this.min_amnt_purchased_value;
        }

        this.formData.voucher_listing_conditions = JSON.stringify(this.formData.voucher_listing_conditions);
        this.formData.voucher_rewards = JSON.stringify(this.formData.voucher_rewards);
        this.formData.voucher_redemption_conditions = JSON.stringify(this.formData.voucher_redemption_conditions);
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/vouchers/' + this.voucherData.id,
          {
            voucher: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },
    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
    },
    clearForm() {
      this.reward = null;
      this.rewardValue = null;
      this.membership_program_id = null;
      this.membership_levels = [];
      this.payment_types = false;
      this.payment_types_value = null;
      this.sites = false;
      this.sites_value = [];
      this.customer_types = false;
      this.customer_types_value = null;
      this.min_amnt_purchased = false;
      this.min_amnt_purchased_value = null;
      this.conditions = [];
      this.formData.name = null;
      this.formData.start_date = null;
      this.formData.end_date = null;
      this.formData.voucher_rewards = {};
      this.formData.voucher_listing_conditions = {};
      this.formData.voucher_redemption_conditions = {};
      this.formData.price = 0.00;
      this.formData.status = 'A';
      this.formData.short_description = null;
      this.formData.terms = null;
      this.formData.title = null;
      this.formData.qty = null;
      this.formData.voucher_type_id = null;
      this.formData.code = null;
      this.formData.codeType = 'constant';
      this.defaultTab = 'voucher-info';
    },
    async setFormData() {
      console.log(this.voucherData)
      const {
        name,
        start_date,
        end_date,
        price,
        status,
        short_description,
        terms,
        title,
        qty,
        voucher_type_id,
        code,
        voucher_rewards,
        voucher_listing_conditions,
        // voucher_redemption_conditions,
      } = this.voucherData;
      
      if(voucher_rewards['amount'] != 'undefined'){
        this.rewardValue = 'amount';
        this.reward = voucher_rewards['amount'];
      }
      if(voucher_rewards['barcodes'] != 'undefined'){
        this.rewardValue = 'barcodes';
        this.reward = voucher_rewards['barcodes'];
      }
      if(voucher_listing_conditions['membership_program'] != 'undefined') {
        this.membership_program_id = voucher_listing_conditions['membership_program'];
        if(voucher_listing_conditions['membership_levels'] != 'undefined') {
          this.getMembershipLevels();
          this.membership_levels = voucher_listing_conditions['membership_levels'];
        }
      }

      if (this.voucherData !== null) {
        this.formData.name = name;
        this.formData.start_date = moment(start_date).format(this.dateFormat).toString();
        this.formData.end_date = moment(end_date).format(this.dateFormat).toString();
        this.formData.price = price;
        this.formData.status = status;
        this.formData.short_description = short_description;
        this.formData.terms = terms;
        this.formData.title = title;
        this.formData.qty = qty;
        this.formData.voucher_type_id = voucher_type_id;
        this.formData.code = code;

        this.defaultTab = 'voucher-info';
      }
    }
  },
  someRef() {
  return this.voucherData !== null;
  },
  created() {
    this.getVoucherTypes();
    this.getSites();
    this.getMembershipPrograms();

    this.setFormData();
  },
  watch: {
    'formData.visiting_sites': function (val) {
      this.options.visiting_sites = [];
      this.options.sites.map((site) => {if(val.includes(site.id)) { this.options.visiting_sites.push(site) }} )
    },
    voucherData: function(newVal) {
      if (newVal !== null) {
        this.setFormData();
      } else {
        this.clearForm();
      }
    },

    drawerVisible: function(val) {
      if (val == false) {
        this.closeDrawer();
      }
    }
  }
};
</script>

<style scoped></style>
